var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXSolidinline = function SvgXSolidinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0C0F",
    d: "M7.23 10.102 2.938 15H.563L6.12 8.653zM8.525 5.494 12.454 1h2.375L9.625 6.951z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0C0F",
    d: "M15.744 15h-4.78L.256 1h4.9zm-4.124-1.421h1.316L4.44 2.347H3.03z"
  })));
};
export default SvgXSolidinline;